'use strict';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { Component } from 'react';
import Layout from 'Layouts/Auth';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import Logo from 'Pure/Logo';
import Link from 'Pure/Link';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import { URL } from 'Shared/Routes';
const {
  app
} = window;
export default class SignInWithThirdPartyPage extends Component {
  state = {};
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    window.setTimeout(component.requestSession, 400);
  }
  requestSession = () => {
    const component = this,
      props = this.props,
      state = this.state;

    // Update user permissions now that user is connected
    app.emit({
      event: 'sessionNeedsRefresh',
      source: 'SignInWithThirdPartyPage',
      data: {
        prevent_loading: true,
        then: function (response = {}) {
          const role = response.user?.roles?.[0];
          if (!role) {
            return component.setState({
              error: 'Connexion invalide.',
              loading: false
            });
          }
          let url = '/';
          if (role === 'admin') {
            url = URL('AdminEtablishmentsDashboard');
          } else if (role === 'hotelier') {
            url = URL('AdminArrivalsDashboard');
          } else if (role === 'company') {
            url = URL('CompanyInformation');
          } else if (role === 'marketing') {
            url = URL('ExportBtoCMarketingDashboard');
          }
          window.setTimeout(function () {
            app.navigateTo(url);
          }, 400);
        }
      }
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const loader = !state.error ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['primary', 'bg-transparent'],
      text: "Connexion..."
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Layout, _extends({
      page_title: "Connexion tierce"
    }, props), /*#__PURE__*/React.createElement("div", {
      className: "login-page__left"
    }, /*#__PURE__*/React.createElement(Link, {
      href: "/",
      className: "home-link"
    }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
      className: "u-margin-right-10"
    }), " Retourner sur le site myWO"), /*#__PURE__*/React.createElement("div", {
      className: "login-page__content"
    }, /*#__PURE__*/React.createElement(Logo, {
      style: {
        display: 'block',
        width: '240px',
        maxWidth: '100%',
        margin: 0
      }
    }), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-positioned u-margin-top-40"
    }, loader), getFormStatus(state))), /*#__PURE__*/React.createElement("div", {
      className: "login-page__right"
    }));
    return output;
  }
}
